import { render, staticRenderFns } from "./BooksStaffTable.vue?vue&type=template&id=3349bd5c&scoped=true&"
import script from "./BooksStaffTable.vue?vue&type=script&lang=js&"
export * from "./BooksStaffTable.vue?vue&type=script&lang=js&"
import style0 from "./BooksStaffTable.vue?vue&type=style&index=0&id=3349bd5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3349bd5c",
  null
  
)

export default component.exports